module.exports = __webpack_public_path__ + "img/out-of-stock.0905ac04.png";